import { render } from "./VButton.vue?vue&type=template&id=7807bce2&scoped=true&ts=true"
import script from "./VButton.vue?vue&type=script&lang=ts"
export * from "./VButton.vue?vue&type=script&lang=ts"

import "./VButton.vue?vue&type=style&index=0&id=7807bce2&lang=scss&scoped=true"

import exportComponent from "/app/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-7807bce2"]])

export default __exports__